<div class="flex flex-col h-full">
  <div class="flex-1 overflow-hidden">
    @if (currentSrc()) {
      <ngx-extended-pdf-viewer
        [src]="currentSrc()!"
        [showToolbar]="showZoomBar()"
        [textLayer]="true"
        [showSidebarButton]="false"
        [showOpenFileButton]="false"
        [showDownloadButton]="false"
        [showPrintButton]="false"
        [showFindButton]="false"
        [showSecondaryToolbarButton]="false"
        [showPagingButtons]="showZoomBar()"
        [showRotateButton]="false"
        [showHandToolButton]="false"
        [showPresentationModeButton]="false"
        [showPropertiesButton]="false"
        [sidebarVisible]="false"
        height="100%"
        (pageRendered)="onPageRendered($any($event))"
        (pdfLoadingFailed)="loadFailed.emit($event)"
      >
      </ngx-extended-pdf-viewer>
    } @else {
      <div class="flex items-center justify-center h-full text-slate-500">No PDF loaded.</div>
    }
  </div>
</div>
